import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ApiService } from 'app/modules/websocket/api.service';
import { adminUiInitialized } from 'app/store/admin-panel/admin.actions';
import { entitlementsLoaded, entitlementsLoadFailed } from 'app/store/entitlements/entitlements.actions';
import { systemInfoUpdated } from 'app/store/system-info/system-info.actions';

@Injectable()
export class EntitlementsEffects {
  private actions$ = inject(Actions);
  private api = inject(ApiService);

  loadEntitlements = createEffect(() => this.actions$.pipe(
    ofType(adminUiInitialized, systemInfoUpdated),
    // Latest wins: `systemInfoUpdated` also fires on unrelated saves, so a second load can
    // start while the first is in flight and must not be overtaken by it.
    switchMap(() => {
      return this.api.call('truenas.entitlements.info').pipe(
        map((info) => entitlementsLoaded({ entitlements: info.features })),
        catchError((error: unknown) => {
          console.error(error);
          return of(entitlementsLoadFailed());
        }),
      );
    }),
  ));
}
